import z from 'zod'
import { CitySchema } from './citySchema'
import { PostalCodeSchema } from './postalCodeSchema'
import { ProvinceSchema } from './provinceSchema'
import { StreetSchema } from './streetSchema'

// Address validation schemas
export const AddressSchema = z.object({
  street: StreetSchema,
  city: CitySchema,
  province: ProvinceSchema,
  postal: PostalCodeSchema,
})
